import { useTranslation } from 'react-i18next';

import { InputContent } from '@/components/common/InputContent/InputContent.tsx';
import { CandidateProfileApi } from '@/api/matchmaker/types.ts';
import { getSmokingOptions } from '@/components/Popup/EditProfile/EditSmokingStatusPopup.tsx';
import { getAlcoholPreferences } from '@/components/Popup/EditProfile/EditAlcoholPreferencePopup.tsx';
import SmokingShape from '@/components/common/svg/shapes/SmokingShape.tsx';
import AlcoholShape from '@/components/common/svg/shapes/AlcoholShape.tsx';
import { AlcoholPreference, SmokingStatus } from '@/enums/apiEnums.ts';
import { tagStyle } from '@/components/UserProfile/styles.ts';

type LifestyleBlockProps = {
  profile_data?: CandidateProfileApi;
};

export const LifestyleBlock = ({ profile_data }: LifestyleBlockProps) => {
  const { t } = useTranslation();

  const smokingOptions = getSmokingOptions(t);
  const alcoholPreferences = getAlcoholPreferences(t);

  const tags: { icon: JSX.Element; label: string }[] = [];

  if (
    profile_data?.smoking_status &&
    profile_data.smoking_status !== SmokingStatus.SMOKING_STATUS_UNSPECIFIED
  ) {
    tags.push({
      icon: <SmokingShape width={18} height={18} fillColor="#FFF" />,
      label: smokingOptions[profile_data.smoking_status]
    });
  }

  if (
    profile_data?.alcohol_preference &&
    profile_data.alcohol_preference !==
      AlcoholPreference.ALCOHOL_PREFERENCE_UNSPECIFIED
  ) {
    tags.push({
      icon: <AlcoholShape width={18} height={18} fillColor="#FFF" />,
      label: alcoholPreferences[profile_data.alcohol_preference]
    });
  }

  if (tags.length === 0) return null;

  return (
    <InputContent
      title={t('lifestyle_section')}
      style={{ marginTop: 10, marginBottom: 10 }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px'
        }}
      >
        {tags.map((tag, index) => (
          <div key={index} style={tagStyle}>
            {tag.icon}
            {tag.label}
          </div>
        ))}
      </div>
    </InputContent>
  );
};
